// tslint:disable
// this is an auto generated file. This will be overwritten

export const listJobs = `query ListJobs {
  listJobs {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const getExecutionHistoryForJobSeekerId = `query GetExecutionHistoryForJobSeekerId(
  $jobSeekerId: ID!
  $first: Int
  $after: ExecutionCursorInput
  $last: Int
  $before: ExecutionCursorInput
) {
  getExecutionHistoryForJobSeekerId(
    jobSeekerId: $jobSeekerId
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      node {
        id
        jobSeekerId
        executionArn
        queuedJobsAtStart
        queueLengthAtStart
        queueLengthAtEnd
        jobsSucceededCount
        jobsSucceeded
        jobsFailedCount
        jobsFailed
        jobsEvaluatedCount
        jobsEvaluated
        passedJobTitleList
        passedJobTitleListCount
        passedJobDescriptionList
        passedJobDescriptionListCount
        jobsAddedToQueue
        jobsAddedToQueueCount
        dateCreated
        dateStarted
      }
      cursor {
        id
        dateCreated
      }
    }
    pageInfo {
      startCursor {
        id
        dateCreated
      }
      endCursor {
        id
        dateCreated
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getUserById = `query GetUserById($userId: String!) {
  getUserById(userId: $userId) {
    id
    email
    emailVerified
    phoneVerified
    companyId
    group
    onboardingCompleted
    firstName
    lastName
    age
    company {
      id
      dateCreated
      dateModified
      ownerId
      ownerEmail
      profile {
        industries
        remotePolicy
        name
        bio
        hasHeadquarters
        hqAddress {
          formatted_address
        }
        emailAddress
        phoneNumber
        image
      }
      publicProfile {
        id
        builtId
        companyAlias
        readableName
        description
        headCount
        website
        careerPage
        stage
        isPublic
        headquarters
        valueMillions
        isUnicorn
        isRemoteFirst
        isHybrid
        isMixed
        workFromAnywhere
        hasFlexibleHours
        isMissionDriven
        linkedinUrl
        crunchbaseUrl
        glassdoorUrl
      }
      jobPostings {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      signupPromo
      website
      deleted
    }
    jobSeeker {
      id
      userId
      firstName
      lastName
      city {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      newGradOrStudent
      linkedin
      website
      currentCompany
      currentTitle
      fullTime
      partTime
      contractor
      fullRemote
      hybridRemote
      remoteOptional
      desiredRole
      salaryRequirement {
        currencyCode
        value
      }
      authorization {
        usAuthorized
        requireSponsorshipUS
      }
      recommendedJobsEmail
      newsletterEmail
      notificationSettings {
        reviewsProfile
      }
      visibleToEmployers
      emailAddress
      phone
      phoneVerified
      profilePic
      experienceLevel
      workHistory {
        company
        title
        startDate
        endDate
        currentJob
        description
      }
      educationHistory {
        institution
        certification
        concentration
        dateStarted
        dateCompleted
        inProgress
        description
      }
      applications {
        id
        jobId
        jobSeekerId
        applicationStatus
        coverLetter
        job {
          aboutUs
          companyId
          companyWebsite
          companyName
          dateCreated
          dateModified
          datePosted
          deleted
          department
          description
          digitalNomadFriendly
          elite
          endSalaryRangeThousands
          experience
          featured
          featuredRank
          flexibleHours
          id
          jobLogo
          jobTitle
          paymentPlan
          remoteFirst
          remotePolicy
          roleType
          scraped
          scrapedSource
          scrapedUrl
          startSalaryRangeThousands
          status
          stripeId
          tags
          timezonePolicy
          wageIsHourly
          willSponsor
          workFromAnywhere
        }
        applicant {
          id
          userId
          firstName
          lastName
          newGradOrStudent
          linkedin
          website
          currentCompany
          currentTitle
          fullTime
          partTime
          contractor
          fullRemote
          hybridRemote
          remoteOptional
          desiredRole
          recommendedJobsEmail
          newsletterEmail
          visibleToEmployers
          emailAddress
          phone
          phoneVerified
          profilePic
          experienceLevel
          preferencesComplete
          profileComplete
          dateCreated
          dateModified
          deleted
        }
        proof
        isAuto
        formScreenshot
        confirmationScreenshot
        generatedResumeUrl
        applicationAnswers {
          id
          applicationId
          jobSeekerId
          jobId
          dateCreated
          dateModified
        }
        resumeS3Params {
          bucket
          key
        }
        dateApplied
        dateAppliedIndex
        dateUpdated
      }
      resume {
        id
        name
        fileType
        size
        url
        resumeJSON
        jobSeekerId
        dateUploaded
        dateCreated
        deleted
      }
      autoResumes {
        id
        name
        fileType
        size
        url
        resumeJSON
        jobSeekerId
        dateUploaded
        dateCreated
        deleted
      }
      preferencesComplete
      profileComplete
      autoApply {
        id
        jobSeekerId
        subId
        userId
        autoGenerateCoverLetter
        autoGenerateCoverLetterTone
        autoGenerateCoverLetterGreeting
        autoGenerateCoverLetterSignOff
        autoGenerateCoverLetterInstructions
        customResumeOptions {
          shouldCustomize
          customInstructions
        }
        openToRelocation
        languagesSpoken
        age
        references {
          name
          email
          phone
          relationship
        }
        genderIdentity
        blockedCompanyList
        resumeText
        coverLetter
        aiGenerateCoverLetter
        coverLetterTone
        draft
        email
        isActive
        firstName
        lastName
        remote
        hybrid
        onsite
        jobTitles
        negativeJobTitles
        industries
        education {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        experienceLevels
        excludeCompanyNames
        expiresAt
        subscribedOn
        plan
        applicationCount
        paymentFailed
        autoLocations {
          country
          region
          area
        }
        location {
          formatted_address
        }
        country
        region
        area
        customPreference
        appliedUrls
        salaryMin
        salaryMax
        salaryRange
        searchTags
        prompt
        phone
        address
        currentCompany
        linkedinProfile
        githubProfile
        website
        gender
        pronouns
        hispanic
        race
        paused
        disabled
        veteran
        countryAuthorization {
          countryAuthorization
          authorizationType
          requiresSponsorship
        }
        secretClearance
        appCountToday
        appCountDateUpdated
        maxPerDay
        maxPerCo
        hourToRun
        minuteToRun
        resumeUrl
        resumeName
        trial
        trialExpired
        gsiConstant
        dateCreated
        cancelled
        searchCustomInstructions
      }
      dateCreated
      dateModified
      deleted
    }
    notifications {
      id
      notificationType
      message
      textMessage
      userId
      url
      read
      dateCreated
      dateRead
    }
    trailUsed
    howDidYouFindUs
    howDidYouFindUsOther
    employmentStatus
    jobSearchStage
    interviewCount
    deleted
  }
}
`;
export const getJobById = `query GetJobById($jobId: String!) {
  getJobById(jobId: $jobId) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const searchJobs = `query SearchJobs($input: SearchInput) {
  searchJobs(input: $input) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const searchJobsByTerm = `query SearchJobsByTerm($input: SearchJobsByTermInput) {
  searchJobsByTerm(input: $input) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const searchJobsByLocation = `query SearchJobsByLocation($input: SearchJobsByLocationInput) {
  searchJobsByLocation(input: $input) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const searchJobsDb = `query SearchJobsDb($input: SearchInput) {
  searchJobsDb(input: $input) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const searchJobsAutoApply = `query SearchJobsAutoApply($input: AutoSearchInput) {
  searchJobsAutoApply(input: $input) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const searchJobsByCompanyNameAndJobTitle = `query SearchJobsByCompanyNameAndJobTitle($input: FeaturedSearchInput) {
  searchJobsByCompanyNameAndJobTitle(input: $input) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const searchJobsByCompanyId = `query SearchJobsByCompanyId($input: JobsByCompanySearch) {
  searchJobsByCompanyId(input: $input) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const findJobs = `query FindJobs($text: String) {
  findJobs(text: $text) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
export const getApplicationsForJobSeekerIdByStatus = `query GetApplicationsForJobSeekerIdByStatus(
  $jobSeekerId: ID
  $status: ApplicationStatus
  $first: Int
  $after: ApplicationCursorInput
  $last: Int
  $before: ApplicationCursorInput
) {
  getApplicationsForJobSeekerIdByStatus(
    jobSeekerId: $jobSeekerId
    status: $status
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      node {
        id
        jobId
        jobSeekerId
        applicationStatus
        coverLetter
        job {
          aboutUs
          companyId
          companyWebsite
          companyName
          dateCreated
          dateModified
          datePosted
          deleted
          department
          description
          digitalNomadFriendly
          elite
          endSalaryRangeThousands
          experience
          featured
          featuredRank
          flexibleHours
          id
          jobLogo
          jobTitle
          paymentPlan
          remoteFirst
          remotePolicy
          roleType
          scraped
          scrapedSource
          scrapedUrl
          startSalaryRangeThousands
          status
          stripeId
          tags
          timezonePolicy
          wageIsHourly
          willSponsor
          workFromAnywhere
        }
        applicant {
          id
          userId
          firstName
          lastName
          newGradOrStudent
          linkedin
          website
          currentCompany
          currentTitle
          fullTime
          partTime
          contractor
          fullRemote
          hybridRemote
          remoteOptional
          desiredRole
          recommendedJobsEmail
          newsletterEmail
          visibleToEmployers
          emailAddress
          phone
          phoneVerified
          profilePic
          experienceLevel
          preferencesComplete
          profileComplete
          dateCreated
          dateModified
          deleted
        }
        proof
        isAuto
        formScreenshot
        confirmationScreenshot
        generatedResumeUrl
        applicationAnswers {
          id
          applicationId
          jobSeekerId
          jobId
          dateCreated
          dateModified
        }
        resumeS3Params {
          bucket
          key
        }
        dateApplied
        dateAppliedIndex
        dateUpdated
      }
      cursor {
        id
        jobSeekerId
        dateApplied
      }
    }
    pageInfo {
      startCursor {
        id
        jobSeekerId
        dateApplied
      }
      endCursor {
        id
        jobSeekerId
        dateApplied
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getApplicationsForJobIdByStatus = `query GetApplicationsForJobIdByStatus(
  $jobId: ID
  $status: ApplicationStatus
  $first: Int
  $after: ApplicationJobIdCursorInput
  $last: Int
  $before: ApplicationJobIdCursorInput
) {
  getApplicationsForJobIdByStatus(
    jobId: $jobId
    status: $status
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      node {
        id
        jobId
        jobSeekerId
        applicationStatus
        coverLetter
        job {
          aboutUs
          companyId
          companyWebsite
          companyName
          dateCreated
          dateModified
          datePosted
          deleted
          department
          description
          digitalNomadFriendly
          elite
          endSalaryRangeThousands
          experience
          featured
          featuredRank
          flexibleHours
          id
          jobLogo
          jobTitle
          paymentPlan
          remoteFirst
          remotePolicy
          roleType
          scraped
          scrapedSource
          scrapedUrl
          startSalaryRangeThousands
          status
          stripeId
          tags
          timezonePolicy
          wageIsHourly
          willSponsor
          workFromAnywhere
        }
        applicant {
          id
          userId
          firstName
          lastName
          newGradOrStudent
          linkedin
          website
          currentCompany
          currentTitle
          fullTime
          partTime
          contractor
          fullRemote
          hybridRemote
          remoteOptional
          desiredRole
          recommendedJobsEmail
          newsletterEmail
          visibleToEmployers
          emailAddress
          phone
          phoneVerified
          profilePic
          experienceLevel
          preferencesComplete
          profileComplete
          dateCreated
          dateModified
          deleted
        }
        proof
        isAuto
        formScreenshot
        confirmationScreenshot
        generatedResumeUrl
        applicationAnswers {
          id
          applicationId
          jobSeekerId
          jobId
          dateCreated
          dateModified
        }
        resumeS3Params {
          bucket
          key
        }
        dateApplied
        dateAppliedIndex
        dateUpdated
      }
      cursor {
        id
        jobId
      }
    }
    pageInfo {
      startCursor {
        id
        jobId
      }
      endCursor {
        id
        jobId
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getNotificationsByUserId = `query GetNotificationsByUserId(
  $userId: String
  $first: Int
  $after: NotificationCursorInput
  $last: Int
  $before: NotificationCursorInput
) {
  getNotificationsByUserId(
    userId: $userId
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      node {
        id
        notificationType
        message
        textMessage
        userId
        url
        read
        dateCreated
        dateRead
      }
      cursor {
        id
        userId
        dateCreated
      }
    }
    pageInfo {
      startCursor {
        id
        userId
        dateCreated
      }
      endCursor {
        id
        userId
        dateCreated
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getApplicationCountsForJobSeekerId = `query GetApplicationCountsForJobSeekerId($jobSeekerId: String) {
  getApplicationCountsForJobSeekerId(jobSeekerId: $jobSeekerId) {
    pendingCount
    acceptedCount
    declinedCount
    reviewCount
    failedCount
    jobId
  }
}
`;
export const getApplicationCountsForJobId = `query GetApplicationCountsForJobId($jobId: String) {
  getApplicationCountsForJobId(jobId: $jobId) {
    pendingCount
    acceptedCount
    declinedCount
    reviewCount
    failedCount
    jobId
  }
}
`;
export const getCompanyProfileByCompanyId = `query GetCompanyProfileByCompanyId($companyId: String) {
  getCompanyProfileByCompanyId(companyId: $companyId) {
    industries
    remotePolicy
    name
    bio
    hasHeadquarters
    hqAddress {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    emailAddress
    phoneNumber
    image
  }
}
`;
export const getFeaturedJobs = `query GetFeaturedJobs(
  $first: Int
  $after: JobCursorInput
  $last: Int
  $before: JobCursorInput
  $includePaused: Boolean
  $department: String
  $tag: JobTag
) {
  getFeaturedJobs(
    first: $first
    after: $after
    last: $last
    before: $before
    includePaused: $includePaused
    department: $department
    tag: $tag
  ) {
    edges {
      node {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      cursor {
        id
        companyId
      }
    }
    pageInfo {
      startCursor {
        id
        companyId
      }
      endCursor {
        id
        companyId
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getLiveJobCount = `query GetLiveJobCount {
  getLiveJobCount
}
`;
export const getFeaturedJobCount = `query GetFeaturedJobCount {
  getFeaturedJobCount
}
`;
export const getCompanyCount = `query GetCompanyCount {
  getCompanyCount
}
`;
export const getCompanies = `query GetCompanies(
  $searchText: String
  $first: Int
  $after: CompanyCursorInput
  $last: Int
  $before: CompanyCursorInput
) {
  getCompanies(
    searchText: $searchText
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      node {
        id
        dateCreated
        dateModified
        ownerId
        ownerEmail
        profile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        publicProfile {
          id
          builtId
          companyAlias
          readableName
          description
          headCount
          website
          careerPage
          stage
          isPublic
          headquarters
          valueMillions
          isUnicorn
          isRemoteFirst
          isHybrid
          isMixed
          workFromAnywhere
          hasFlexibleHours
          isMissionDriven
          linkedinUrl
          crunchbaseUrl
          glassdoorUrl
        }
        jobPostings {
          aboutUs
          companyId
          companyWebsite
          companyName
          dateCreated
          dateModified
          datePosted
          deleted
          department
          description
          digitalNomadFriendly
          elite
          endSalaryRangeThousands
          experience
          featured
          featuredRank
          flexibleHours
          id
          jobLogo
          jobTitle
          paymentPlan
          remoteFirst
          remotePolicy
          roleType
          scraped
          scrapedSource
          scrapedUrl
          startSalaryRangeThousands
          status
          stripeId
          tags
          timezonePolicy
          wageIsHourly
          willSponsor
          workFromAnywhere
        }
        signupPromo
        website
        deleted
      }
      cursor {
        id
        companyName
      }
    }
    pageInfo {
      startCursor {
        id
        companyName
      }
      endCursor {
        id
        companyName
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getLiveJobs = `query GetLiveJobs(
  $first: Int
  $after: JobCursorInput
  $last: Int
  $before: JobCursorInput
) {
  getLiveJobs(first: $first, after: $after, last: $last, before: $before) {
    edges {
      node {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      cursor {
        id
        companyId
      }
    }
    pageInfo {
      startCursor {
        id
        companyId
      }
      endCursor {
        id
        companyId
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getAllJobSeekers = `query GetAllJobSeekers(
  $first: Int
  $after: JobSeekerCursorInput
  $last: Int
  $before: JobSeekerCursorInput
) {
  getAllJobSeekers(first: $first, after: $after, last: $last, before: $before) {
    edges {
      node {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      cursor {
        id
        userId
      }
    }
    pageInfo {
      startCursor {
        id
        userId
      }
      endCursor {
        id
        userId
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getAutoApplyUsers = `query GetAutoApplyUsers(
  $first: Int
  $after: AutoCursorInput
  $last: Int
  $before: AutoCursorInput
) {
  getAutoApplyUsers(
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      node {
        id
        jobSeekerId
        subId
        userId
        autoGenerateCoverLetter
        autoGenerateCoverLetterTone
        autoGenerateCoverLetterGreeting
        autoGenerateCoverLetterSignOff
        autoGenerateCoverLetterInstructions
        customResumeOptions {
          shouldCustomize
          customInstructions
        }
        openToRelocation
        languagesSpoken
        age
        references {
          name
          email
          phone
          relationship
        }
        genderIdentity
        blockedCompanyList
        resumeText
        coverLetter
        aiGenerateCoverLetter
        coverLetterTone
        draft
        email
        isActive
        firstName
        lastName
        remote
        hybrid
        onsite
        jobTitles
        negativeJobTitles
        industries
        education {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        experienceLevels
        excludeCompanyNames
        expiresAt
        subscribedOn
        plan
        applicationCount
        paymentFailed
        autoLocations {
          country
          region
          area
        }
        location {
          formatted_address
        }
        country
        region
        area
        customPreference
        appliedUrls
        salaryMin
        salaryMax
        salaryRange
        searchTags
        prompt
        phone
        address
        currentCompany
        linkedinProfile
        githubProfile
        website
        gender
        pronouns
        hispanic
        race
        paused
        disabled
        veteran
        countryAuthorization {
          countryAuthorization
          authorizationType
          requiresSponsorship
        }
        secretClearance
        appCountToday
        appCountDateUpdated
        maxPerDay
        maxPerCo
        hourToRun
        minuteToRun
        resumeUrl
        resumeName
        trial
        trialExpired
        gsiConstant
        dateCreated
        cancelled
        searchCustomInstructions
      }
      cursor {
        id
        dateCreated
      }
    }
    pageInfo {
      startCursor {
        id
        dateCreated
      }
      endCursor {
        id
        dateCreated
      }
      hasNextPage
      hasPreviousPage
    }
  }
}
`;
export const getJobSeekerById = `query GetJobSeekerById($id: String) {
  getJobSeekerById(id: $id) {
    id
    userId
    firstName
    lastName
    city {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    newGradOrStudent
    linkedin
    website
    currentCompany
    currentTitle
    fullTime
    partTime
    contractor
    fullRemote
    hybridRemote
    remoteOptional
    desiredRole
    salaryRequirement {
      currencyCode
      value
    }
    authorization {
      usAuthorized
      requireSponsorshipUS
    }
    recommendedJobsEmail
    newsletterEmail
    notificationSettings {
      reviewsProfile
    }
    visibleToEmployers
    emailAddress
    phone
    phoneVerified
    profilePic
    experienceLevel
    workHistory {
      company
      title
      startDate
      endDate
      currentJob
      description
    }
    educationHistory {
      institution
      certification
      concentration
      dateStarted
      dateCompleted
      inProgress
      description
    }
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    resume {
      id
      name
      fileType
      size
      url
      resumeJSON
      jobSeekerId
      dateUploaded
      dateCreated
      deleted
    }
    autoResumes {
      id
      name
      fileType
      size
      url
      resumeJSON
      jobSeekerId
      dateUploaded
      dateCreated
      deleted
    }
    preferencesComplete
    profileComplete
    autoApply {
      id
      jobSeekerId
      subId
      userId
      autoGenerateCoverLetter
      autoGenerateCoverLetterTone
      autoGenerateCoverLetterGreeting
      autoGenerateCoverLetterSignOff
      autoGenerateCoverLetterInstructions
      customResumeOptions {
        shouldCustomize
        customInstructions
      }
      openToRelocation
      languagesSpoken
      age
      references {
        name
        email
        phone
        relationship
      }
      genderIdentity
      blockedCompanyList
      resumeText
      coverLetter
      aiGenerateCoverLetter
      coverLetterTone
      draft
      email
      isActive
      firstName
      lastName
      remote
      hybrid
      onsite
      jobTitles
      negativeJobTitles
      industries
      education {
        institution
        certification
        concentration
        dateStarted
        dateCompleted
        inProgress
        description
      }
      educationHistory {
        institution
        certification
        concentration
        dateStarted
        dateCompleted
        inProgress
        description
      }
      experienceLevels
      excludeCompanyNames
      expiresAt
      subscribedOn
      plan
      applicationCount
      paymentFailed
      autoLocations {
        location {
          formatted_address
        }
        country
        region
        area
      }
      location {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      country
      region
      area
      customPreference
      appliedUrls
      salaryMin
      salaryMax
      salaryRange
      searchTags
      prompt
      phone
      address
      currentCompany
      linkedinProfile
      githubProfile
      website
      gender
      pronouns
      hispanic
      race
      paused
      disabled
      veteran
      countryAuthorization {
        countryAuthorization
        authorizationType
        requiresSponsorship
      }
      secretClearance
      appCountToday
      appCountDateUpdated
      maxPerDay
      maxPerCo
      hourToRun
      minuteToRun
      resumeUrl
      resumeName
      trial
      trialExpired
      gsiConstant
      dateCreated
      cancelled
      searchCustomInstructions
    }
    dateCreated
    dateModified
    deleted
  }
}
`;
export const getAutoApplyUsersByEmail = `query GetAutoApplyUsersByEmail($email: String) {
  getAutoApplyUsersByEmail(email: $email) {
    id
    jobSeekerId
    subId
    userId
    autoGenerateCoverLetter
    autoGenerateCoverLetterTone
    autoGenerateCoverLetterGreeting
    autoGenerateCoverLetterSignOff
    autoGenerateCoverLetterInstructions
    customResumeOptions {
      shouldCustomize
      customInstructions
    }
    openToRelocation
    languagesSpoken
    age
    references {
      name
      email
      phone
      relationship
    }
    genderIdentity
    blockedCompanyList
    resumeText
    coverLetter
    aiGenerateCoverLetter
    coverLetterTone
    draft
    email
    isActive
    firstName
    lastName
    remote
    hybrid
    onsite
    jobTitles
    negativeJobTitles
    industries
    education {
      institution
      certification
      concentration
      dateStarted
      dateCompleted
      inProgress
      description
    }
    educationHistory {
      institution
      certification
      concentration
      dateStarted
      dateCompleted
      inProgress
      description
    }
    experienceLevels
    excludeCompanyNames
    expiresAt
    subscribedOn
    plan
    applicationCount
    paymentFailed
    autoLocations {
      location {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      country
      region
      area
    }
    location {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    country
    region
    area
    customPreference
    appliedUrls
    salaryMin
    salaryMax
    salaryRange
    searchTags
    prompt
    phone
    address
    currentCompany
    linkedinProfile
    githubProfile
    website
    gender
    pronouns
    hispanic
    race
    paused
    disabled
    veteran
    countryAuthorization {
      countryAuthorization
      authorizationType
      requiresSponsorship
    }
    secretClearance
    appCountToday
    appCountDateUpdated
    maxPerDay
    maxPerCo
    hourToRun
    minuteToRun
    resumeUrl
    resumeName
    trial
    trialExpired
    gsiConstant
    dateCreated
    cancelled
    searchCustomInstructions
  }
}
`;
export const searchTests = `query SearchTests {
  searchTests {
    id
    name
  }
}
`;
export const aggregateCompaniesByJobBoard = `query AggregateCompaniesByJobBoard($offset: Int, $jobBoard: String) {
  aggregateCompaniesByJobBoard(offset: $offset, jobBoard: $jobBoard) {
    aboutUs
    applications {
      id
      jobId
      jobSeekerId
      applicationStatus
      coverLetter
      job {
        aboutUs
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        applicationQuestions {
          id
          jobId
        }
        companyId
        communications {
          emails
          phone
        }
        companyProfile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          emailAddress
          phoneNumber
          image
        }
        companyWebsite
        companyName
        dateCreated
        dateModified
        datePosted
        deleted
        department
        description
        digitalNomadFriendly
        elite
        endSalaryRangeThousands
        experience
        featured
        featuredRank
        flexibleHours
        id
        jobLogo
        jobTitle
        officeFrequency {
          daysPerMonth
          daysPerWeek
        }
        officeLocations {
          formatted_address
        }
        paymentHistory {
          stripeId
          productId
          paymentPlan
          dateCreated
          dateEnded
        }
        paymentPlan
        remoteFirst
        remotePolicy
        roleType
        scraped
        scrapedSource
        scrapedUrl
        startSalaryRangeThousands
        status
        stripeId
        tags
        timezonePolicy
        timezoneRanges {
          start
          end
        }
        wageIsHourly
        willSponsor
        workFromAnywhere
      }
      applicant {
        id
        userId
        firstName
        lastName
        city {
          formatted_address
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        recommendedJobsEmail
        newsletterEmail
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        phoneVerified
        profilePic
        experienceLevel
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        applications {
          id
          jobId
          jobSeekerId
          applicationStatus
          coverLetter
          proof
          isAuto
          formScreenshot
          confirmationScreenshot
          generatedResumeUrl
          dateApplied
          dateAppliedIndex
          dateUpdated
        }
        resume {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        autoResumes {
          id
          name
          fileType
          size
          url
          resumeJSON
          jobSeekerId
          dateUploaded
          dateCreated
          deleted
        }
        preferencesComplete
        profileComplete
        autoApply {
          id
          jobSeekerId
          subId
          userId
          autoGenerateCoverLetter
          autoGenerateCoverLetterTone
          autoGenerateCoverLetterGreeting
          autoGenerateCoverLetterSignOff
          autoGenerateCoverLetterInstructions
          openToRelocation
          languagesSpoken
          age
          genderIdentity
          blockedCompanyList
          resumeText
          coverLetter
          aiGenerateCoverLetter
          coverLetterTone
          draft
          email
          isActive
          firstName
          lastName
          remote
          hybrid
          onsite
          jobTitles
          negativeJobTitles
          industries
          experienceLevels
          excludeCompanyNames
          expiresAt
          subscribedOn
          plan
          applicationCount
          paymentFailed
          country
          region
          area
          customPreference
          appliedUrls
          salaryMin
          salaryMax
          salaryRange
          searchTags
          prompt
          phone
          address
          currentCompany
          linkedinProfile
          githubProfile
          website
          gender
          pronouns
          hispanic
          race
          paused
          disabled
          veteran
          secretClearance
          appCountToday
          appCountDateUpdated
          maxPerDay
          maxPerCo
          hourToRun
          minuteToRun
          resumeUrl
          resumeName
          trial
          trialExpired
          gsiConstant
          dateCreated
          cancelled
          searchCustomInstructions
        }
        dateCreated
        dateModified
        deleted
      }
      proof
      isAuto
      formScreenshot
      confirmationScreenshot
      generatedResumeUrl
      applicationAnswers {
        id
        applicationId
        jobSeekerId
        jobId
        responses {
          id
          question
          answer
          type
        }
        dateCreated
        dateModified
      }
      resumeS3Params {
        bucket
        key
      }
      dateApplied
      dateAppliedIndex
      dateUpdated
    }
    applicationQuestions {
      id
      jobId
      questions {
        question
        type
        selector
        options
      }
    }
    companyId
    communications {
      emails
      phone
    }
    companyProfile {
      industries
      remotePolicy
      name
      bio
      hasHeadquarters
      hqAddress {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      emailAddress
      phoneNumber
      image
    }
    companyWebsite
    companyName
    dateCreated
    dateModified
    datePosted
    deleted
    department
    description
    digitalNomadFriendly
    elite
    endSalaryRangeThousands
    experience
    featured
    featuredRank
    flexibleHours
    id
    jobLogo
    jobTitle
    officeFrequency {
      daysPerMonth
      daysPerWeek
    }
    officeLocations {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    paymentHistory {
      stripeId
      productId
      paymentPlan
      dateCreated
      dateEnded
    }
    paymentPlan
    remoteFirst
    remotePolicy
    roleType
    scraped
    scrapedSource
    scrapedUrl
    startSalaryRangeThousands
    status
    stripeId
    tags
    timezonePolicy
    timezoneRanges {
      start
      end
    }
    wageIsHourly
    willSponsor
    workFromAnywhere
  }
}
`;
